//#region src/utils/safens.ts
const SAFE_NS_NAME_REGEX = /^(?!.*(^(?!@)|[-.@])($|[-.@]))(?:[a-z0-9-]{0,63}(?:\.[a-z0-9-]{0,63})*)?@[a-z0-9-]{0,63}$/i;
const SAFE_NS_DOMAIN_REGEX = /^(?!.*(^|[-.])($|[-.]))(?:[a-z0-9-]{0,63}\.)+safe$/i;
const MAX_SAFE_NS_NAME_LENGTH = 235;
function isValidSafeNSName(name) {
	if (name.length > MAX_SAFE_NS_NAME_LENGTH) return false;
	if (name.includes("@")) return SAFE_NS_NAME_REGEX.test(name);
	return SAFE_NS_DOMAIN_REGEX.test(name);
}
function normalizeSafeNSName(name, format = "at") {
	const lowerCase = name.toLowerCase();
	let parts;
	if (lowerCase.includes("@")) {
		if (!SAFE_NS_NAME_REGEX.test(lowerCase)) throw new Error(`Invalid SafeNS name ${name}`);
		const [labels, domain] = lowerCase.split("@");
		parts = [...labels ? labels.split(".") : [], domain];
	} else {
		if (!SAFE_NS_DOMAIN_REGEX.test(lowerCase)) throw new Error(`Invalid SafeNS name ${name}`);
		parts = lowerCase.split(".").slice(0, -1);
	}
	if (format === "dot") return `${parts.join(".")}.safe`;
	return `${parts.slice(0, -1).join(".")}@${parts[parts.length - 1]}`;
}
//#endregion
export { isValidSafeNSName, normalizeSafeNSName };

//# sourceMappingURL=safens.mjs.map